import { IconDefinition } from "./types";

/**
 * @deprecated Use `spinnerThird` instead. This icon will be removed in a future version.
 */
const loading: IconDefinition = {
  iconName: "loading",
  width: 512,
  height: 512,
  svgPathData:
    "M477.7 384C499.5 346.4 512 302.6 512 256 512 114.6 397.4 0 256 0l0 48c114.9 0 208 93.1 208 208 0 37.9-10.1 73.4-27.8 104l41.6 24z",
  iconType: "fill",
  unicode: 0xf3f4,
};

export { loading };
